var SurveyForm = require('./form/Survey.js')
var SurveyAnswers = require('./answers/Survey.js')
var Backbone = require('backbone')
var $ = require('jquery')

module.exports = Backbone.Model.extend({
  relations: {
    form: SurveyForm,
    answers: SurveyAnswers
  },

  urlRoot: '/survey',

  defaults: {
    id: null,
    form: {},
    answers: [],
    current: 0,
    hasParticipated: false,
    userIsGuest: true,
    userId: null
  },

  parse: function (obj) {
    this.get('form').get('items').reset(obj.survey.items || [])
    this.set(
      'hasParticipated',
      obj.hasParticipated || this.checkParticipationLocalStorage()
    )
  },

  currentIsLastItem: function () {
    return this.get('current') === this.get('form').get('items').length
  },

  prevItem: function () {
    var current = this.get('current')
    if (current === 0) return
    this.set('current', this.get('current') - 1)
  },

  nextItem: function () {
    if (this.currentIsLastItem()) return
    this.set('current', this.get('current') + 1)
  },

  getParticipationFromStorage: function () {
    var val = window.localStorage.getItem(this.storageKey)
    if (!val) return []
    return val.split(',')
  },

  setSurveyParticiaptionLocalStorage: function () {
    if (!window.localStorage) return

    var surveysParticipated = this.getParticipationFromStorage()
    surveysParticipated.push(this.get('id'))
    window.localStorage.setItem(this.storageKey, surveysParticipated.join(','))
  },

  checkParticipationLocalStorage: function () {
    if (!window.localStorage) return false

    var surveys = this.getParticipationFromStorage()
    return surveys.indexOf(this.get('id')) > -1
  },

  submitParticipation: function () {
    this.set('hasParticipated', true)

    // Refresh the CSRF token
    $.get('/site/_tokens?name=survey').done(
      function (data) {
        $.post('/survey/' + this.get('id'), {
          answers: JSON.stringify(this.get('answers').toJSON()),
          _token: data._token
        })
      }.bind(this)
    )

    this.setSurveyParticiaptionLocalStorage()
  },

  resetAnswers: function () {
    var answers = []
    var itemsLength = this.get('form').get('items').length
    for (var k = 0; k < itemsLength; k++) {
      answers.push(null)
    }
    this.set('answers', new SurveyAnswers(answers))
  },

  initialize: function () {
    this.storageKey = 'survey_' + this.get('userId')

    this.set('hasParticipated', this.checkParticipationLocalStorage())
    this.listenTo(
      this.get('form').get('items'),
      'all',
      this.resetAnswers.bind(this)
    )
  }
})
